import request from '@/utils/request'

//6.1获取商品分类
export function getitemtypetree(lang) {
    return request({
        url: `/${lang}/wms/dqgx/getitemtypetree`,
        method: 'get'
    })
}

//6.2获取商品列表
export function getItemlist(lang, data, pageReq) {
    return request({
        url: `/${lang}/wms/dqgx/getItemlist`,
        method: 'post',
        data,
        params: pageReq
    })
}

//6.3商品详情
export function getItemdetail(lang, itemNo) {
    return request({
        url: `/${lang}/wms/dqgx/getItemdetail/${itemNo}`,
        method: 'get'
    })
}